"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinksWrap = exports.MenuLink = exports.InputWrapper = exports.Nav = exports.MenuWrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const components_1 = require("../../common/components");
const notLaptop = 'only screen and (max-width: 1400px)';
const firstBreakPoint = 'only screen and (max-width: 1100px)';
exports.MenuWrap = app_1.styled.div `
  display: flex;
  align-items: center;
`;
exports.Nav = (0, app_1.styled)(components_1.Nav) `
  display: grid;
  grid-gap: ${(theme) => theme.spacing.extraSmall};
  grid-template-columns:
    calc(2 * ${(theme) => theme.spacing.large}) minmax(0, 16rem)
    repeat(4, minmax(0, 1fr)) 10rem;

  > a:nth-of-type(2) {
    grid-column-start: 4;
  }
  @media ${notLaptop} {
    grid-template-columns:
      calc(2 * ${(theme) => theme.spacing.large}) minmax(0, 16rem)
      repeat(4, minmax(0, 1fr)) 10rem;
  }
  @media ${firstBreakPoint} {
    grid-template-columns:
      ${(theme) => theme.spacing.large} minmax(0, 2fr)
      repeat(4, minmax(0, 1fr)) 10rem;
  }
  @media ${app_1.notDesktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas: 'logo lang';
    padding: 0;
  }
`;
exports.InputWrapper = app_1.styled.div `
  ${(theme) => theme.flexCenter};
  @media ${app_1.notDesktop} {
    display: none;
    grid-area: input;
    > div {
      width: 100%;
      padding-left: ${(theme) => theme.spacing.extraSmall};
      padding-right: ${(theme) => theme.spacing.extraSmall};
    }
  }
`;
const menuLinkStyle = {
    link: (0, app_1.css) `
    width: min-content;
    height: min-content;
    justify-self: center;
  `,
};
exports.MenuLink = (0, app_1.styled)(app_1.Link) `
  ${(theme) => theme.flexCenter};
  width: 100%;
  height: 100%;
  ${(_theme, props) => props.$linkStyle && menuLinkStyle.link};
  &:hover {
    text-decoration: underline;
  }
  transition: all 0.3s;
`;
exports.LinksWrap = (0, app_1.styled)(ui_1.Stack) `
  grid-column: ${(_theme, { $changeLang }) => $changeLang ? `span 5` : `span 6`};
  justify-content: flex-end;
  margin-right: ${(theme, { $changeLang }) => $changeLang ? `unset` : theme.spacing.medium};

  grid-column: 3 / span 5;
  @media ${notLaptop} {
    > * {
      > span > span {
        letter-spacing: 0.1em;
      }
    }
  }
  @media ${app_1.notDesktop} {
    display: none;
  }
`;
